<template lang="pug">
.container-fluid
  //- h1 Sales Platforms
  .card.shadow.mb-4
    .card-header.py-3.d-flex.flex-row.align-items-center.justify-content-between
      h2.m-0.font-weight-bold.text-primary Sales Platforms
      button.btn.btn-primary.text-right(v-on:click="openForm()")  
        i.fas.fa-fw.fa-plus-square
        |Platform    
    .card-body
      .col-12.table-wrap        
        div(style="text-align:center" v-if="loading")
          Spinner(size="medium" message="Loading...")
        .col-12(v-else)
        transition( name="fade")
          table#tablePreview.table(v-if="!loading")
            thead
              tr
                th Actions
                th.cursor(@click="alphabetize()") 
                  |Platform Name
                  span(v-show="alphabetized") &nbsp; A-Z
                th Platform URL
                th Platform Type
            tbody(v-show="!alphabetized")
              tr(v-for="(channel, index) in allChannels" )
                td.connectActions.text-center
                  i.fas.fa-fw.fa-tools.cursor(v-on:click="widgetInfo(channel)" title="Widget")
                  i.fas.fa-fw.fa-edit.cursor(@click="updateChannel(channel)" title="Update Platform")
                  i.fas.fa-fw.fa-minus-circle.cursor(@click="delChannel(channel._id)" title="Delete")
                td(v-if="channel.nickname !='null'") {{channel.nickname}}
                td(v-else) N/A
                td {{channel.store}}
                td {{channel.type}}
            tbody(v-show="alphabetized")
              tr(v-for="(channel, index) in alphabetizeChannels" )
                th                  
                  i.fas.fa-fw.fa-tools.cursor(v-on:click="widgetInfo(channel)" title="Widget")
                  i.fas.fa-fw.fa-minus-circle.cursor(@click="delChannel(channel._id)" title="Delete")
                td(v-if="channel.nickname !='null'") {{channel.nickname}}
                td(v-else) N/A
                td {{channel.store}}
                td {{channel.type}}
      transition( name="fade")
        .connectionFormWrap(v-if="connectionForm")
          .connectionContainer
            .connectiongogo(ref="returnOrderForm")
              ConnectPlatform(
                :oAuthReturn="$route.query"
                :gandalf="false"
                @init="init"
                @closeForm="closeForm"
              )
          .connectionFormBg(v-on:click="closeForm")
      transition( name="fade")
        .connectionFormWrap(v-if="updateChannelForm")
          .connectionContainer
            .connectiongogo(ref="returnOrderForm")
              UpdatePlatform(
                :channelInfo="channelInfo"
                :gandalf="false"
                @init="init"
                @closeForm="closeForm"        
              )
          .connectionFormBg(v-on:click="closeForm")
      transition( name="fade" )
        .connectionFormWrap(v-if="widgetModal")
          .connectionContainer
            .connectiongogo
              WidgetInfo(
                :widget="widget"
                @closeForm="closeForm"
              )
          .connectionFormBg(v-on:click="closeForm")
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Spinner from 'vue-simple-spinner'
import ConnectPlatform from '@/components/ConnectPlatform'
import UpdatePlatform from '@/components/UpdatePlatform'
import WidgetInfo from '@/components/WidgetInfo'

export default {
  name: 'ConnectPlatforms',
  components:{
    Spinner,
    ConnectPlatform,
    UpdatePlatform,
    WidgetInfo
  },//nickname Store Name &v store.   order no api -> channel -> order
  props: {

  },
  computed:{
    ...mapState(['allChannels', 'shopifyChannels','apiChannels', 'amazonChannels']),       
    alphabetizeChannels(){    
      if(this.allChannels){  
      var x =[ ...this.allChannels]
      x.sort((a, b) => a.nickname.localeCompare(b.nickname)); 
      return x}
      else return ''
    }
  },
  data:function(){
    return{
      alphabetized:false,
      loading:true,
      carrier:true,
      connectionForm:false,
      updateChannelForm:false,
      channelInfo:null,
      orderInfo:null,
      editOrder:null,
      channelsList:null,
      widgetModal:false,
      widget:null,     

    }
  },  
  methods:{
    ...mapActions(['updateUser']),

    alphabetize(){      
      this.alphabetized = !this.alphabetized;      
    },
    async init(){
      this.loading = true;
      var x = await this.updateUser();  
      this.loading = false;
    },
    updateChannel(channelInfo){
      this.updateChannelForm = true;
      this.channelInfo = channelInfo;
    },
    openForm(){
      this.connectionForm = true;
    },
    closeForm(){
      this.connectionForm = false;
      this.updateChannelForm = false;
      this.connetionInfo = null;
      this.widgetModal = null;
    },
    async delChannel(id){
      var x = confirm('Are you sure you want to delete?')
      if(x){
        this.flash('Deleting...','warning')
        var bodyFormData = new FormData()
        bodyFormData.append('channelId', id)
        var response = await this.axios.post(`/rp/server/channel/delete/?`,bodyFormData)
        if(response.data.success){
          this.flash(response.data.success.message,'success')
        }else{
          this.flash(response.data.error.message,'error')
        }
        this.init()
      }
    },    
    widgetInfo(info){      
      this.widgetModal = true;
      this.widget = info;
    },   
    
  },
  mounted(){
    this.init()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.connectActions{
  display:flex;
  i{
    margin:0 3px;
  }
}
.table-wrap{
  overflow:auto;
}
 .connectionFormWrap{
    position:fixed;
    display:flex;
    justify-content: center;
    align-items: center;
    width:100vw;
    height:100vh;
    top:0;
    left:0;
    .connectionContainer{
      width:80vw;
      max-height:800px;
      // padding:50px;
      background:white;
      border-radius: 10px;      
      box-shadow: 0px 0px 10px 1px rgba(0,0,0,.5);
      z-index: 9;
      .connectiongogo{
        max-width:90vw;
        max-height:80vh;
        overflow:auto;
        border-radius: 5px;
      }
    }
    .connectionFormBg{
      width:100%;
      height:100%;
      z-index: -1;
      position: absolute;
      top:0;
      background:rgba(0,0,0,.2);
    }

  }
  @media all and (max-width:768px) {
    .connectActions{
      i:first-child{
        margin-left:0;
      }
      i{
        margin:0 5px;
      }
    }
    .card-header{
      flex-flow: wrap;
    }
    .connectionFormWrap{
      width:100vw;
      height:100vh;
      top:0;
      left:0;
      .connectionContainer{
        width:90vw;
        .connectiongogo{
          max-width:90vw;
          max-height:80vh;
          overflow:auto;
        }
      }
      

    }
  }
</style>
